
import { useState, useEffect } from "react";

interface UserProfile {
  avatarUrl: string | null;
  name: string;
}

export function useUserProfile(): UserProfile {
  const [profile, setProfile] = useState<UserProfile>({
    avatarUrl: null,
    name: "Coach"
  });

  useEffect(() => {
    // Get stored user info from localStorage
    const storedAvatar = localStorage.getItem('userAvatar');
    const storedName = localStorage.getItem('userName') || "Coach";
    
    setProfile({
      avatarUrl: storedAvatar && storedAvatar !== "/placeholder.svg" ? storedAvatar : null,
      name: storedName
    });
  }, []);

  return profile;
}
